var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#e4f1ff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0037ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0037ff",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0037ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0072ff",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#54a0ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0072ff",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#54a0ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#9bcbff",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_4",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#e4f1ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#9bcbff",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0037ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0037ff",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0072ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#0037ff",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#0072ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#54a0ff",
    stopOpacity: 1
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#9bcbff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#54a0ff",
    stopOpacity: 1
  })))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_4",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#9bcbff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#e4f1ff",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 405.6C-57.4 401 -114.8 396.4 -151.5 365.9C-188.3 335.4 -204.3 279 -243.2 243.2C-282.1 207.5 -343.9 192.3 -374.7 155.2C-405.6 118.1 -405.6 59.1 -405.6 0L0 0Z",
    fill: "#bfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 324.5C-45.9 320.8 -91.8 317.1 -121.2 292.7C-150.6 268.3 -163.5 223.2 -194.6 194.6C-225.7 166 -275.1 153.9 -299.8 124.2C-324.5 94.5 -324.5 47.2 -324.5 0L0 0Z",
    fill: "#77b6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 243.4C-34.4 240.6 -68.9 237.8 -90.9 219.5C-113 201.2 -122.6 167.4 -145.9 145.9C-169.3 124.5 -206.3 115.4 -224.8 93.1C-243.4 70.9 -243.4 35.4 -243.4 0L0 0Z",
    fill: "#2e8aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 162.2C-23 160.4 -45.9 158.5 -60.6 146.3C-75.3 134.1 -81.7 111.6 -97.3 97.3C-112.9 83 -137.6 76.9 -149.9 62.1C-162.2 47.2 -162.2 23.6 -162.2 0L0 0Z",
    fill: "#0057ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 81.1C-11.5 80.2 -23 79.3 -30.3 73.2C-37.7 67.1 -40.9 55.8 -48.6 48.6C-56.4 41.5 -68.8 38.5 -74.9 31C-81.1 23.6 -81.1 11.8 -81.1 0L0 0Z",
    fill: "#0037ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -405.6C41.9 -373.7 83.8 -341.8 135.5 -327.1C187.2 -312.3 248.7 -314.8 286.8 -286.8C325 -258.8 339.8 -200.2 355.7 -147.3C371.6 -94.4 388.6 -47.2 405.6 0L0 0Z",
    fill: "#bfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -324.5C33.5 -299 67 -273.4 108.4 -261.6C149.7 -249.9 198.9 -251.9 229.5 -229.5C260 -207 271.8 -160.2 284.6 -117.9C297.3 -75.6 310.9 -37.8 324.5 0L0 0Z",
    fill: "#77b6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -243.4C25.1 -224.2 50.3 -205.1 81.3 -196.2C112.3 -187.4 149.2 -188.9 172.1 -172.1C195 -155.3 203.9 -120.1 213.4 -88.4C223 -56.7 233.2 -28.3 243.4 0L0 0Z",
    fill: "#2e8aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -162.2C16.8 -149.5 33.5 -136.7 54.2 -130.8C74.9 -124.9 99.5 -125.9 114.7 -114.7C130 -103.5 135.9 -80.1 142.3 -58.9C148.6 -37.8 155.4 -18.9 162.2 0L0 0Z",
    fill: "#0057ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -81.1C8.4 -74.7 16.8 -68.4 27.1 -65.4C37.4 -62.5 49.7 -63 57.4 -57.4C65 -51.8 68 -40 71.1 -29.5C74.3 -18.9 77.7 -9.4 81.1 0L0 0Z",
    fill: "#0037ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/bg3.2238be87c16d454fb87fbb3b775b227d.svg";
export { ForwardRef as ReactComponent };